import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';

import AWS, { config as AWSConfig } from 'aws-sdk/global';
import S3 from 'aws-sdk/clients/s3';

import { HairCut, HairColor, Perm, HairStraightening, HairTreatment, HeadSpa, Note } from './Treatments'; // eslint-disable
import PhotoWidget from './PhotoWidget/PhotoWidget';
import Modal from '../../../components/Modal/RecieverFragments';

import getStylistToolContent from '../../../redux/actions/stylistTool';
import { saveNewSalonVisit } from '../../../redux/actions/hairDiagnosis';
import { getDeveloperRanges, getColorRanges } from '../../../redux/selectors/stylistTool';
import { getCurrentDiagnosisUser } from '../../../redux/selectors/hairDiagnosis';

import { BLACK } from '../../../styles/variables.style';

import { uuidv4 } from '../../../utils';

import config from '../../../config';

import {
  Wrapper,
  Inner,
  AddTreatmentsWrapper,
  RowWrapper,
  AddTreatmentsBtn,
  AddNoteBtn,
  SaveDetailsBtn,
  Icon,
  OptionsList,
  AddTreatmentsBtnWrapper,
  TreatmentBtn,
  TreatmentsList,
  Navigation,
  CurrentPage,
  NextPage,
  Spinner,
} from './NewVisitPage.style';

class NewVisitPage extends Component {
  state = {
    treatmentsOpen: false,
    treatments: [],
    beforeImages: [],
    afterImages: [],
    errorOnSave: false,
    loading: false,
    cancelModal: false,
    saveModal: false,
  };

  componentDidMount() {
    const { currentDiagnosisUser, history, developerRanges, colorRanges, locale, getStylistToolContent } = this.props;

    if (!currentDiagnosisUser) {
      history.push(`/${locale}/stylist/retrieve-profile`);
    }

    if (developerRanges.length === 0 && colorRanges.length === 0) {
      getStylistToolContent(locale);
    }

    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillReceiveProps(nextProps) {
    const { currentDiagnosisUser, history, locale } = nextProps;
    if (!currentDiagnosisUser) {
      return;
    }
    if (currentDiagnosisUser.salonVisits.length > this.props.currentDiagnosisUser.salonVisits.length) {
      const getLastVisit = currentDiagnosisUser.salonVisits.sort(
        (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      )[0];
      history.push(`/${locale}/stylist/visit/${getLastVisit.id}`);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  button = React.createRef();

  handleClickOutside = e => {
    if (this.button && this.button.current && !this.button.current.contains(e.target)) {
      this.setState({
        treatmentsOpen: false,
        errorOnSave: false,
      });
    }
  };

  handleToggleTreatments = () => {
    this.setState(({ treatmentsOpen }) => ({
      treatmentsOpen: !treatmentsOpen,
      errorOnSave: false,
    }));
  };

  handleAddTreatment = (typeComponent, type) => () => {
    this.setState(({ treatments }) => ({
      treatments: treatments.concat({ typeComponent, type }),
    }));
  };

  handleAddNote = () => {
    this.setState(({ treatments }) => ({
      treatments: treatments.concat({
        typeComponent: Note,
        type: 'note',
        value: '',
      }),
      errorOnSave: false,
    }));
  };

  handleRemoveTreatment = i => () => {
    this.setState(({ treatments }) => ({
      treatments: [...treatments.slice(0, i), ...treatments.slice(i + 1)],
      errorOnSave: false,
    }));
  };

  handleUpdateNote = i => ev => {
    const { treatments } = this.state;
    this.setState({
      treatments: [...treatments.slice(0, i), { ...treatments[i], value: ev.target.value }, ...treatments.slice(i + 1)],
      errorOnSave: false,
    });
  };

  handleUpdateTreatment = i => data => {
    const { treatments } = this.state;
    const newData = treatments[i].type === 'hairColor' ? { recipes: data } : data;
    this.setState({
      treatments: [...treatments.slice(0, i), { ...treatments[i], ...newData }, ...treatments.slice(i + 1)],
      errorOnSave: false,
    });
  };

  handleBeforeImage = imageObj => {
    this.setState(({ beforeImages }) => ({
      beforeImages: beforeImages.concat(imageObj),
      errorOnSave: false,
    }));
  };

  handleAfterImage = dataUri => {
    this.setState(({ afterImages }) => ({
      afterImages: afterImages.concat(dataUri),
      errorOnSave: false,
    }));
  };

  handleRemoveAfterImage = index => {
    this.setState(({ afterImages }) => ({
      afterImages: [...afterImages.slice(0, index), ...afterImages.slice(index + 1)],
      errorOnSave: false,
    }));
  };

  handleRemoveBeforeImage = index => {
    this.setState(({ beforeImages }) => ({
      beforeImages: [...beforeImages.slice(0, index), ...beforeImages.slice(index + 1)],
      errorOnSave: false,
    }));
  };

  uploadImages = cb => {
    const { beforeImages, afterImages } = this.state;
    const { auth } = this.props;

    const loginKey = `cognito-idp.${process.env.REACT_APP_BUCKET_REGION}.amazonaws.com/${config.COGNITO_USERPOOL}`;

    AWSConfig.region = process.env.REACT_APP_BUCKET_REGION;
    AWSConfig.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
      Logins: {
        [loginKey]: auth.info.idToken.jwtToken,
      },
    });

    // needs to be refreshed before using new credentials
    AWSConfig.credentials.refresh(error => {
      if (error) {
        console.error(error);
      } else {
        const s3 = new S3({
          apiVersion: '2006-03-01',
        });

        let promises = [];
        if (beforeImages.length > 0) {
          promises = promises.concat(
            Promise.all(
              beforeImages.map(image => {
                let imageExtension = image.dataUri.split(';')[0].split('/');
                imageExtension = imageExtension[imageExtension.length - 1];
                return s3
                  .upload({
                    Key: `assets/${uuidv4()}.${imageExtension}`,
                    Body: image.arrayBuffer,
                    ACL: 'authenticated-read',
                    Bucket: process.env.REACT_APP_DYNAMIC_ASSETS_BUCKET,
                  })
                  .promise();
              })
            )
          );
        }
        if (afterImages.length > 0) {
          promises = promises.concat(
            Promise.all(
              afterImages.map(image => {
                let imageExtension = image.dataUri.split(';')[0].split('/');
                imageExtension = imageExtension[imageExtension.length - 1];
                return s3
                  .upload({
                    Key: `assets/${uuidv4()}.${imageExtension}`,
                    Body: image.arrayBuffer,
                    ACL: 'authenticated-read',
                    Bucket: process.env.REACT_APP_DYNAMIC_ASSETS_BUCKET,
                  })
                  .promise();
              })
            )
          );
        }

        if (promises.length > 0) {
          Promise.all(promises)
            .then(values => {
              const beforeImages = values[0];
              const afterImages = values[1];
              cb(beforeImages, afterImages);
            })
            .catch(err => {
              this.setState({
                errorOnSave: true,
                loading: false,
              });
            });
        }
      }
    });
  };

  handleSaveDetails = () => {
    const { beforeImages, afterImages } = this.state;
    this.setState(
      {
        loading: true,
        errorOnSave: false,
        cancelModal: false,
        saveModal: false,
      },
      () => {
        if (beforeImages.length === 0 && afterImages.length === 0) {
          this.handleSaveUserInfo();
        } else {
          this.uploadImages((bI, aI) => {
            this.handleSaveUserInfo(bI, aI);
          });
        }
      }
    );
  };

  handleSaveUserInfo = (beforeImages, afterImages) => {
    const { treatments } = this.state;
    const { currentDiagnosisUser, colorRanges, saveNewSalonVisit, stylist } = this.props;

    if (treatments.length === 0) {
      this.setState({
        errorOnSave: false,
        loading: false,
      });
      return;
    }

    const hasNote = treatments.find(t => t.type === 'note');
    const hasHairColor = treatments.find(t => t.type === 'hairColor');
    const userInfo = {
      salonVisit: {
        stylist,
        beforeAndAfter: {
          before: [],
          after: [],
        },
        hairCut: !!treatments.find(t => t.type === 'hairCut'),
        hairStraightening: !!treatments.find(t => t.type === 'hairStraightening'),
        hairTreatment: !!treatments.find(t => t.type === 'hairTreatment'),
        perm: !!treatments.find(t => t.type === 'perm'),
        headSpa: !!treatments.find(t => t.type === 'headSpa'),
        notes: hasNote ? hasNote.value : '',
        hairColorRecipes: hasHairColor
          ? hasHairColor.recipes.map(recipe => ({
              services: recipe.services,
              hairAgents: recipe.products.map(recipeProduct => {
                const currentRange = colorRanges.find(range => range.name === recipeProduct.range);
                let hex = '';
                if (currentRange) {
                  currentRange.colorGroups.forEach(colorGroup =>
                    colorGroup.colors.forEach(color => {
                      if (color.name === recipeProduct.product) {
                        hex = color.colorCode;
                      }
                    })
                  );
                }
                return {
                  agentType: recipeProduct.type,
                  range: recipeProduct.range,
                  agentName: recipeProduct.product,
                  ratio: recipeProduct.ratio,
                  hex,
                };
              }),
            }))
          : [],
      },
    };

    if (beforeImages) {
      userInfo.salonVisit.beforeAndAfter.before = beforeImages.map(image => image.key);
    }

    if (afterImages) {
      userInfo.salonVisit.beforeAndAfter.after = afterImages.map(image => image.key);
    }

    saveNewSalonVisit({
      ...userInfo,
      hash: currentDiagnosisUser.hash,
    }).catch(err => {
      this.setState({
        errorOnSave: true,
        loading: false,
      });
    });
  };

  handleShowModal = () => {
    this.setState({
      saveModal: true,
    });
  };

  handleShowCancelModal = () => {
    this.setState({
      cancelModal: true,
    });
  };

  handleHideModal = () => {
    this.setState({
      saveModal: false,
      cancelModal: false,
    });
  };

  handleExit = () => {
    const { history, locale } = this.props;
    this.setState(
      {
        cancelModal: false,
      },
      () => {
        history.push(`/${locale}/stylist/visits`);
      }
    );
  };

  isValidForm = () => {
    const { treatments } = this.state;
    if (treatments.length === 0) {
      return false;
    }

    const hairColorTreatment = treatments.find(t => t.type === 'hairColor');
    if (hairColorTreatment && (!hairColorTreatment.recipes || hairColorTreatment.recipes)) {
      return false;
    }
    const note = treatments.find(t => t.type === 'note');
    if (note && !note.value.trim()) {
      return false;
    }

    return true;
  };

  render() {
    const {
      treatmentsOpen,
      treatments,
      beforeImages,
      afterImages,
      errorOnSave,
      loading,
      cancelModal,
      saveModal,
    } = this.state;
    const { locale, developerRanges, colorRanges, copy } = this.props;
    return (
      <Wrapper>
        <Helmet>
          <body style={`background-color: ${BLACK}; ${(saveModal || cancelModal) ? 'overflow: hidden;' : ''}`} /> {/* eslint-disable-line */}
        </Helmet>
        <Navigation>
          <NextPage>
            <Link to={`/${locale}/stylist/profile`} href={`/${locale}/stylist/profile`}>
              {copy.customer_profile}
            </Link>
          </NextPage>
          <CurrentPage>{copy.salon_visit}</CurrentPage>
        </Navigation>
        <Inner>
          <PhotoWidget
            beforeImages={beforeImages}
            afterImages={afterImages}
            updateBeforeImages={this.handleBeforeImage}
            updateAfterImages={this.handleAfterImage}
            removeBeforeImages={this.handleRemoveBeforeImage}
            removeAfterImages={this.handleRemoveAfterImage}
            copy={copy}
            onShowCancelModal={this.handleShowCancelModal}
          />
          {treatments.length > 0 && (
            <TreatmentsList>
              {treatments.map((treatment, i) => {
                const TreatmentItem = treatment.typeComponent;
                return (
                  <li key={treatment.type} style={{ marginTop: '30px' }}>
                    <TreatmentItem
                      onRemove={this.handleRemoveTreatment(i)}
                      treatment={treatment}
                      onUpdateTreatment={
                        treatment.type === 'note' ? this.handleUpdateNote(i) : this.handleUpdateTreatment(i)
                      }
                      ranges={{ developerRanges, colorRanges }}
                      value={treatment.type === 'note' && treatment.value}
                      copy={copy}
                    />
                  </li>
                );
              })}
            </TreatmentsList>
          )}
          <AddTreatmentsWrapper>
            {errorOnSave && <p style={{ fontSize: '14px', color: 'red', marginBottom: 0 }}>{copy.save_error}</p>}
            <RowWrapper>
              <AddTreatmentsBtnWrapper>
                <AddTreatmentsBtn onClick={this.handleToggleTreatments} innerRef={this.button}>
                  <Icon open={treatmentsOpen} />
                  <span>{copy.add_treatments}</span>
                </AddTreatmentsBtn>
                <OptionsList open={treatmentsOpen}>
                  <ul>
                    <li>
                      <TreatmentBtn
                        onClick={this.handleAddTreatment(HairCut, 'hairCut')}
                        disabled={treatments.find(t => t.type === 'hairCut')}
                      >
                        + {copy.hair_cut}
                      </TreatmentBtn>
                    </li>
                    <li>
                      <TreatmentBtn
                        onClick={this.handleAddTreatment(HairColor, 'hairColor')}
                        disabled={treatments.find(t => t.type === 'hairColor')}
                      >
                        + {copy.hair_color}
                      </TreatmentBtn>
                    </li>
                    <li>
                      <TreatmentBtn
                        onClick={this.handleAddTreatment(Perm, 'perm')}
                        disabled={treatments.find(t => t.type === 'perm')}
                      >
                        + {copy.perm}
                      </TreatmentBtn>
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <TreatmentBtn
                        onClick={this.handleAddTreatment(HairStraightening, 'hairStraightening')}
                        disabled={treatments.find(t => t.type === 'hairStraightening')}
                      >
                        + {copy.hair_straightening}
                      </TreatmentBtn>
                    </li>
                    <li>
                      <TreatmentBtn
                        onClick={this.handleAddTreatment(HairTreatment, 'hairTreatment')}
                        disabled={treatments.find(t => t.type === 'hairTreatment')}
                      >
                        + {copy.hair_treatment}
                      </TreatmentBtn>
                    </li>
                    <li>
                      <TreatmentBtn
                        onClick={this.handleAddTreatment(HeadSpa, 'headSpa')}
                        disabled={treatments.find(t => t.type === 'headSpa')}
                      >
                        + {copy.head_spa}
                      </TreatmentBtn>
                    </li>
                  </ul>
                </OptionsList>
              </AddTreatmentsBtnWrapper>
              <AddNoteBtn onClick={this.handleAddNote} disabled={treatments.find(t => t.type === 'note')}>
                <Icon />
                <span>{copy.add_note}</span>
              </AddNoteBtn>
            </RowWrapper>
            <SaveDetailsBtn onClick={this.handleShowModal} disabled={loading || !this.isValidForm()}>
              {loading ? <Spinner /> : copy.save_details}
            </SaveDetailsBtn>
          </AddTreatmentsWrapper>
        </Inner>
        <Modal
          isOpen={cancelModal || saveModal}
          hasHeader={false}
          onClose={this.handleHideModal}
          contentBodyItems={[
            {
              type: 'TEXT_BUTTON_BUTTON',
              item: {
                saveModal,
                copy,
                handleSaveDetails: this.handleSaveDetails,
                handleExit: this.handleExit,
              },
            },
          ]}
          styleType="partnersNewVisitType"
        />
      </Wrapper>
    );
  }
}

NewVisitPage.defaultProps = {
  currentDiagnosisUser: null,
  copy: {
    note: 'Note',
    perm: 'Perm',
    after: 'After',
    color: 'Color',
    photo: 'Photo',
    ratio: 'Ratio',
    before: 'Before',
    cancel: 'Cancel',
    others: 'Others',
    ratio2: '2',
    ratio3: '3',
    ratio4: '4',
    recipe: 'Recipe',
    add_more: 'Add More',
    add_note: 'Add note',
    hair_cut: 'Hair cut',
    head_spa: 'Head spa',
    developer: 'Developer',
    foil_work: 'Foil Work',
    hair_color: 'Hair color',
    new_growth: 'New Growth',
    save_agent: 'Save Agent',
    save_error: 'An error has occurred, please try again.',
    salon_visit: 'Salon Visit',
    colored_hair: 'Colored Hair',
    product_type: 'Product Type',
    save_details: 'Save Details',
    add_treatments: 'Add treatments',
    hair_treatment: 'Hair treatment',
    proceed_to_save: 'Proceed to save',
    customer_profile: 'Customer Profile',
    create_new_recipe: 'Create New Recipe',
    hair_straightening: 'Hair straightening',
    modal_confirmation:
      'You will not be able to edit salon visit details after it has been saved. Would you like to proceed?',
  },
};

NewVisitPage.propTypes = {
  locale: PropTypes.string.isRequired,
  developerRanges: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  colorRanges: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  getStylistToolContent: PropTypes.func.isRequired,
  auth: PropTypes.shape({}).isRequired,
  currentDiagnosisUser: PropTypes.shape({
    salonVisits: PropTypes.arrayOf(PropTypes.shape()),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  saveNewSalonVisit: PropTypes.func.isRequired,
  stylist: PropTypes.shape({}).isRequired,
  copy: PropTypes.shape({}),
};

const mapState = state => ({
  locale: state.locale,
  developerRanges: getDeveloperRanges(state),
  colorRanges: getColorRanges(state),
  auth: state.auth,
  currentDiagnosisUser: getCurrentDiagnosisUser(state),
  stylist: state.user,
  copy: state.siteOptions.siteCopyStylistToolNewVisitPage,
});

const mapDispatch = dispatch => ({
  getStylistToolContent: locale => dispatch(getStylistToolContent(locale)),
  saveNewSalonVisit: profile => dispatch(saveNewSalonVisit(profile)),
});

export default connect(mapState, mapDispatch)(NewVisitPage);



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/NewVisitPage/NewVisitPage.js